<template>
  <div>
    <template v-if="infoPlatform">
      เชื่อมต่อแล้วโดย อีเมล {{ infoPlatform.email }}
      <v-btn color="primary" @click="syncPlatform">
        {{ $t('ไปที่ ZWIZ AI PLATFORM') }}
      </v-btn>
    </template>
    <template v-else>
      <v-btn color="primary" @click="syncPlatform">
        {{ $t('Connect') }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  data: function() {
    return {
      infoPlatform: null
    }
  },
  mounted() {
    this.getInfoPlatform()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    async getInfoPlatform() {
      var res = await api.platFormAccountInfo()
      if (res.result) {
        this.infoPlatform = res.result
        // console.log(this.infoPlatform)
      }
    },
    syncPlatform() {
      window.open(
        `https://app.zwiz.ai/login?adminid=${this.$store.state.userid}&sessiontoken=${this.$store.state.accessToken}`
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/SyncRichmenuLogin.vue